export interface SubscriptionAdvisorModel {
  readonly userId: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly profilePictureUrl: string;
  readonly addons: readonly string[];
  readonly completedAccount: boolean;
  readonly package: string;
  readonly email?: string;
  readonly phoneNumber?: string;
  readonly officePhoneNumber?: string;
  readonly companyAdmin: boolean;
  readonly address?: SubscriptionAdvisorAddressModel;
}

export interface SubscriptionAdvisorAddressModel {
  readonly street?: string;
  readonly houseNumber?: string;
  readonly zip?: string;
  readonly city?: string;
  readonly country?: string;
  readonly addressSupplement?: string;
}

export interface SubscriptionPaymentProfileModel {
  readonly companyName: string;
  readonly addressLine1: string;
  readonly addressLine2: string;
  readonly city: string;
  readonly state: string;
  readonly postalCode: string;
  readonly country: string;
  readonly email: string;
  readonly defaultPaymentMethodId: string;
  readonly paymentMethods: PaymentMethodModel[];
}

export interface UpdatePaymentProfileModel {
  companyName: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state?: string;
  postalCode: string;
  country: string;
  email: string;
}

export interface PaymentMethodModel {
  type: string;
  id: string;
  brand: string;
  country: string;
  lastFourDigits: string;
  expMonth: number;
  expYear: number;
}

export interface SubscriptionInvoiceResponseModel {
  readonly data: SubscriptionInvoiceModel[];
  readonly cursor: string;
}

export interface SubscriptionInvoiceModel {
  readonly id: string;
  readonly dueAmountInCents: number;
  readonly paidAmountInCents: number;
  readonly refundedAmountInCents: number;
  readonly invoiceDate: string;
  readonly status: 'OPEN' | 'PAID' | 'PARTIALLY_REFUNDED' | 'REFUNDED' | 'CANCELED';
  readonly pdfUrl: string;
  readonly invoiceNumber: string;
}

export interface SubscriptionProductModel {
  readonly name: string;
  readonly type: 'PACKAGE' | 'ADDON';
  readonly displayName: string;
  readonly description: string;
  readonly badgeColor: string;
  readonly features: string[];
  readonly monthlyPriceInCents: number;
  readonly licensedSeats: number;
  readonly activeSeats: number;
}
